/**
 * Created by Julio Perez on 6/22/2017.
 */
routes.$inject = ['$stateProvider'];

export default function routes($stateProvider) {

    $stateProvider
        .state('appView.footerSection', {
            url: ':section/:toggle',
            views: {
                "footer-section@appView": {
                    template: require('./index.html')
                }
            }
        })

}


// WEBPACK FOOTER //
// ./src/app/views/footer-section/footer-section.routes.js